import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import client from '../api/client';

export default function Election() {
  const { admin } = useAdminAuth();
  const navigate = useNavigate();
  const [election, setElection] = useState(null);
  const [auditLog, setAuditLog] = useState([]);
  const [electionName, setElectionName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!admin) { navigate('/admin/login'); return; }
    loadElection();
    loadAuditLog();
  }, [admin, navigate]);

  const loadElection = () => {
    client.get('/election').then(res => {
      setElection(res.data);
      setElectionName(res.data.name);
    }).catch(() => {});
  };

  const loadAuditLog = () => {
    client.get('/admin/audit-log').then(res => setAuditLog(res.data)).catch(() => {});
  };

  const handleUpdateName = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await client.put('/election', { name: electionName });
      setSuccess('Election name updated');
      loadElection();
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  const handleOpen = async () => {
    setError(''); setSuccess('');
    try {
      await client.post('/election/open');
      setSuccess('Election opened');
      loadElection();
      loadAuditLog();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to open election');
    }
  };

  const handleClose = async () => {
    if (!window.confirm('Close the election? This cannot be undone.')) return;
    setError(''); setSuccess('');
    try {
      await client.post('/election/close');
      setSuccess('Election closed');
      loadElection();
      loadAuditLog();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to close election');
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Election Management</h1>
        <Link to="/admin/dashboard" className="btn-secondary">Back</Link>
      </div>

      {error && <div className="error-msg">{error}</div>}
      {success && <div className="success-msg">{success}</div>}

      {election && (
        <div className="card">
          <h2>Current Election</h2>
          <p>Status: <strong className={`status-${election.status}`}>{election.status.toUpperCase()}</strong></p>
          <form onSubmit={handleUpdateName} style={{ marginTop: '1rem' }}>
            <div className="form-group">
              <label>Election Name</label>
              <input
                type="text"
                value={electionName}
                onChange={e => setElectionName(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn-primary">Update Name</button>
          </form>
          <div className="election-actions" style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
            {election.status !== 'open' && (
              <button onClick={handleOpen} className="btn-primary">Open Election</button>
            )}
            {election.status === 'open' && (
              <button onClick={handleClose} className="btn-danger">Close Election</button>
            )}
          </div>
        </div>
      )}

      <div className="card">
        <h2>Audit Log</h2>
        <div className="audit-list">
          {auditLog.map(entry => (
            <div key={entry.id} className="audit-entry">
              <span className="audit-action">{entry.action}</span>
              <span className="audit-details">{entry.details}</span>
              <span className="audit-time">{new Date(entry.created_at).toLocaleString()}</span>
              {entry.admin_username && <span className="audit-admin">by {entry.admin_username}</span>}
            </div>
          ))}
          {auditLog.length === 0 && <p>No audit entries yet.</p>}
        </div>
      </div>
    </div>
  );
}
